import {mapGetters, mapMutations} from 'vuex';
import {BrowserClient, Hub} from '@sentry/browser';
import VanguardConfig from '../../../config/vanguard';
import * as mutations from '@/common/store/mutations';

export default {
  computed: {
    ...mapGetters([
      'sfId',
      'sentry',
      'trackingCode'
    ])
  },
  methods: {
    ...mapMutations({
      setSentry: mutations.SET_SENTRY
    }),
    sentryInit(prefix) {
      const revision = process.env.GIT_REVISION;
      const sentry = new Hub(new BrowserClient({
        dsn: VanguardConfig.sentryDsn,
        release: `${prefix} - ${revision}`,
        environment: process.env.NODE_ENV
      }));

      sentry.configureScope(scope => {
        if (this.sfId) {
          scope.setUser({sfId: this.sfId});
        }

        if (this.trackingCode) {
          scope.setExtra('trackingCode', this.trackingCode);
        }

        scope.setExtras({
          URL: document.location.href,
          cookies: document.cookie
        });
      });

      this.setSentry(sentry);
    },
    sendSentryLog(level, message, extraParameters = {}, user = null, vueLogger = true) {
      if (vueLogger) {
        if (extraParameters.error) {
          this.$log.error(message, extraParameters.error);
        } else {
          this.$log.error(message);
        }
      }

      this.sentry.withScope(scope => {
        scope.setLevel(level);

        if (user) {
          scope.setUser(user);
        }

        Object.keys(extraParameters).forEach(key => extraParameters[key] === undefined && delete extraParameters[key]);
        if (extraParameters) {
          scope.setExtras(extraParameters);
        }

        this.sentry.captureMessage(message);
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/mixins/sentry-logger.js